import styled from '@emotion/styled';
import { TransitionGroup } from 'react-transition-group';
import { breakpoints, spacing } from '@naf/theme';
import { GridCol } from '@naf/grid';

/** Shared with `ArticleItemCard`, which is the only other thing that lays out a grid cell. */
export const CardGridWrapper = styled(GridCol)`
  margin-bottom: 30px;
  @media (max-width: ${breakpoints.m}) {
    margin-bottom: 0;
  }
`;

export const TransitionGrid = styled(TransitionGroup)`
  grid-column: 1 / -1;
`;

export const EmptyMessagesWrapper = styled.div`
  text-align: center;
  padding-top: ${spacing.space48};
  padding-bottom: ${spacing.space64};
  p {
    margin-top: ${spacing.space8};
  }
  h2 {
    margin-bottom: ${spacing.space8};
  }
  div {
    margin: 0 auto;
  }
`;
